import { CREATE_ORDER_DATA_FAILURE, CREATE_ORDER_DATA_REQUEST, CREATE_ORDER_DATA_RESET, CREATE_ORDER_DATA_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const createOrderData = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ORDER_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case CREATE_ORDER_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case CREATE_ORDER_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case CREATE_ORDER_DATA_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: null, error: null, data: null, result: null });
        default:
            return state;
    }
};
export default createOrderData;
